import { Component } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";

import { createNewHeaders, updateHeaders, clientSettings, executeGet, executePost } from '../../functions/Kubuku';
import { LIST_CONTENT_TOKO, CUD_OUTLET } from '../../api';
import { CHOOSE_CONTENT } from '../../api';
import { DELETE_CONTENT_TOKO } from '../../api';
import ModalChooseContent from '../../components/ModalChooseContent';
import QRCode from "react-qr-code";
import ModalSettings from '../../components/ModalSettings';
import ModalLoading from "../../components/ModalLoading";
import ModalPopup from "../../components/ModalPopup";
import ModalQR from "../../components/ModalQR"
import Pagination from '../../components/Pagination';
import CardKategori from '../../components/CardKategori';

import {
  useParams,
  useNavigate
} from "react-router-dom";
let PageSize = 15;
class ContentToko extends Component {

  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      showMain: false,
      showModal: false,
      isLoading: false,
      showLoading: false,
      data: '',
      msg: '',
      keyword:'',
      halaman:0,
      total:0,
      next_data: true,
      data_more: [],
      batas: 24,
      placeholder: 'Cari Konten yang dijual di toko',
      isQR: false
    }
  }

  componentDidMount() {
    this.getOutlet();
    this.moreData();
  }

  scriptLoaded() {
    console.log("script load");
    // window.A.sort();
  }

  getOutlet = async () => {
    try {
      const flagOpen = localStorage.getItem('flagOpen');
      console.log("flagOpen = " + flagOpen);
      if(flagOpen != "1") {
        createNewHeaders('', ''); 
      } else {
        updateHeaders('', ''); 
      }
      this.setState({showMain: true, isLoading:false });
      
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  }
  onQR = async (url) => {
      this.setState({ isLoading: false, isQR: true, msg: url });
  }
  moreData = async () => {
    try {
      let index = "";
      let idx = "";
      
      let formData = new FormData();
      formData.append("page", (this.state.halaman + 1));
      formData.append("rows", this.state.batas);

      formData.append("table", "_konten");
      formData.append("keyword", this.state.keyword);

      const json = await executePost(CHOOSE_CONTENT, formData);
      //let json = await executePost(LIST_CONTENT_TOKO, formData);
      console.log("MORE CONTENT = " + JSON.stringify(json));

      if (json.code == 200) {
        console.log(json.data);
        var joinData = this.state.data_more;
        if (json.total>0) {
          joinData = joinData.concat(json.data);
        }
        index = json.idx;
        this.setState({
          data_more: joinData,
          index: index,
          next_data: true,
          total: json.total
        }, () => {
          //console.log("contentData = " + this.state.contentData);
        });
        this.setState({halaman: (this.state.halaman+1)})
      } else if (json.cod = 404) {
        this.setState({ next_data: false });
      }

    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  }

    currentTableData = () => {
        const firstPageIndex = (this.state.currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return this.state.data.slice(firstPageIndex, lastPageIndex);
    };

    currencyFormat(num) {
        return 'Rp. ' + parseFloat(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

  deleteOutlet = async (param) => {
    console.log("param del = " + JSON.stringify(param));
    this.setState({ isLoading: true });
    
    try {
      let formData = new FormData();
      formData.append("kode_konten", param.kode_konten);
      //alert(param.kode_konten)
      const json = await executePost(DELETE_CONTENT_TOKO, formData);
      console.log("delete_outlet = " + JSON.stringify(json));
      if (json.code == 200) {
        this.setState({ isLoading: false, isModal: true, msg: json.msg});
        //this.getOutlet();
        this.cari();
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
    
  }

  cari = async() => {
    try {
        this.setState({
          halaman:0,
          data_more:[]
        });
        this.moreData();
      } catch (error) {
        //console.log(error);
        this.setState({ isError: true, errorMessage: "Network Error!" });
      }
  }
  _handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      console.log('do validate ' + this.state.keyword);
      this.cari();
      
      this.setState({
        data_more: [],
        halaman:0
      })
    }
  }

  render() {
    let pjg = 0;
    if (this.state.data_more.length!=null) {
      pjg = this.state.data_more.length;
    }
    console.log("HAL " + this.state.halaman + " --- " + pjg);
    console.log("TOTAL "+this.state.total);
    return (
      <div>
        {
          this.state.isLoading &&
          <ModalLoading />
        }
        {
            this.state.isQR &&
            <ModalQR
                type="success"
                messages={this.state.msg}
                press={() => { this.setState({ isQR: false }) }}
            />
        }
        {
          this.state.isModal &&
          <ModalPopup
            type="success"
            messages={this.state.msg}
            press={() => { this.setState({ isModal: false }) }}
          />
        }

        {
          this.state.showModal &&
          <ModalChooseContent
                close={() => {
                    this.setState({ showModal: false });
                    //this.getEtalase();
                }}
            />
        }

        {
          this.state.showMain &&
          <div className="dark:bg-white border rounded-2xl md:p-[30px] p-[15px] mb-20">
            <div className="text-[24px] font-semibold dark:text-black">Pengaturan Konten Toko</div>
            
            <div className="pb-2 relative text-gray-600 focus-within:text-gray-400 lg:w-12/12 xs:w-12/12">
                <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                <button type="submit" className="p-1 focus:outline-none focus:shadow-outline">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-[20px] w-[20px]" fill="none" viewBox="0 0 24 24" stroke="#E3E3E3">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </button>
                </span>

                <input type="search" name="search" onChange={event => this.setState({ keyword: event.target.value })} onKeyDown={this._handleKeyDown} className="py-3 text-sm text-gray-900 pr-4 bg-transparent border-solid border-grayWalang border rounded-full pl-10 focus:outline-none focus:bg-white focus:text-gray-900 w-full" placeholder={this.state.placeholder} autoComplete="on" />

            </div>
            <div>
              <button onClick={() => { this.setState({ showModal: true }) }} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                <div className="text-[#ffffff] pr-4">
                  Tambah Konten
                </div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 17V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M7 12L17 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </button>
              <div className='pt-2'>
                {console.log("JUMLAH " + this.state.total)}
                
                  <InfiniteScroll
                      dataLength={pjg}
                      next={this.moreData}
                      hasMore={this.state.next_data}
                    >
                      
                      <div className="w-full">
                      <div className='grid grid-cols-2 gap-x-1 gap-y-1  lg:gap-x-2 lg:gap-y-2 md:grid-cols-4 lg:grid-cols-6 lg:mx-2 px-4 lg:px-0 mt-1 space-x-2'>
                          {this.state.data_more.map(item => {
                            return (
                              <div className="bg-white relative mb-2 shadow">
                                  <div>
                                  <img className='w-full product-img' src={item.cover} alt="" />
                                  </div>
                                  <div className='pl-2 pr-2 pt-2'>
                                  <div className="line-clamp-2 text-sm font-semibold">{item.judul}</div>
                                  <div className="line-clamp-1 text-grayWalangDark text-[10px] pt-1">{item.penulis}</div>
                                  <div className="line-clamp-1 text-grayWalangDark text-[10px] pt-1">{item.penerbit}</div>
                                  <div className="flex items-center  pt-2">
                                      <div className="items-center">
                                          <div className="items-center flex cursor-pointer" onClick={() => { this.deleteOutlet(item) }}>
                                            <svg className='h-6 w-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22.5172 16.7795L23.26 16.8829L22.5172 16.7795ZM22.2549 18.6645L22.9977 18.7679L22.2549 18.6645ZM9.74514 18.6645L10.488 18.5611L9.74514 18.6645ZM9.4828 16.7795L8.73996 16.8829L9.4828 16.7795ZM13.1836 25.7368L12.8921 26.4278L13.1836 25.7368ZM10.4751 22.5603L11.1791 22.3017L10.4751 22.5603ZM21.5249 22.5603L22.2289 22.819V22.819L21.5249 22.5603ZM18.8164 25.7368L18.5248 25.0458H18.5248L18.8164 25.7368ZM9.74664 12.9291C9.70746 12.5167 9.34142 12.2142 8.92906 12.2534C8.5167 12.2925 8.21418 12.6586 8.25336 13.0709L9.74664 12.9291ZM23.7466 13.0709C23.7858 12.6586 23.4833 12.2925 23.0709 12.2534C22.6586 12.2142 22.2925 12.5167 22.2534 12.9291L23.7466 13.0709ZM24 11.75C24.4142 11.75 24.75 11.4142 24.75 11C24.75 10.5858 24.4142 10.25 24 10.25V11.75ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75V10.25ZM20 11V11.75H20.75V11H20ZM12 11H11.25V11.75H12V11ZM21.7744 16.6761L21.512 18.5611L22.9977 18.7679L23.26 16.8829L21.7744 16.6761ZM10.488 18.5611L10.2256 16.6761L8.73996 16.8829L9.0023 18.7679L10.488 18.5611ZM16 25.25C14.4708 25.25 13.9254 25.2358 13.4752 25.0458L12.8921 26.4278C13.6891 26.7642 14.6056 26.75 16 26.75V25.25ZM9.0023 18.7679C9.282 20.7777 9.43406 21.9017 9.77109 22.819L11.1791 22.3017C10.9116 21.5736 10.7785 20.6488 10.488 18.5611L9.0023 18.7679ZM13.4752 25.0458C12.5528 24.6566 11.695 23.7058 11.1791 22.3017L9.77109 22.819C10.3857 24.4918 11.4821 25.8328 12.8921 26.4278L13.4752 25.0458ZM21.512 18.5611C21.2215 20.6488 21.0884 21.5736 20.8209 22.3017L22.2289 22.819C22.5659 21.9017 22.718 20.7777 22.9977 18.7679L21.512 18.5611ZM16 26.75C17.3944 26.75 18.3109 26.7642 19.1079 26.4278L18.5248 25.0458C18.0746 25.2358 17.5292 25.25 16 25.25V26.75ZM20.8209 22.3017C20.305 23.7058 19.4472 24.6566 18.5248 25.0458L19.1079 26.4278C20.5179 25.8328 21.6143 24.4918 22.2289 22.819L20.8209 22.3017ZM10.2256 16.6761C10.0035 15.08 9.83766 13.887 9.74664 12.9291L8.25336 13.0709C8.34819 14.069 8.51961 15.2995 8.73996 16.8829L10.2256 16.6761ZM23.26 16.8829C23.4804 15.2995 23.6518 14.069 23.7466 13.0709L22.2534 12.9291C22.1623 13.887 21.9965 15.08 21.7744 16.6761L23.26 16.8829ZM24 10.25H8V11.75H24V10.25ZM19.25 10V11H20.75V10H19.25ZM20 10.25H12V11.75H20V10.25ZM12.75 11V10H11.25V11H12.75ZM16 6.75C17.7949 6.75 19.25 8.20507 19.25 10H20.75C20.75 7.37665 18.6234 5.25 16 5.25V6.75ZM16 5.25C13.3766 5.25 11.25 7.37665 11.25 10H12.75C12.75 8.20507 14.2051 6.75 16 6.75V5.25Z" fill="#F51212" />
                                            </svg>
                                          
                                            <a className="text-black text-sm text-center text-[10px] text-rose-500">Delete</a>
                                          </div>

                                      </div>
                                      
                                  </div>
                                  </div>
                              </div>
                          )
                          })}
                        </div>
                      </div>
                      {this.state.total>= this.state.batas && 
                        <div className="text-center">
                          <center>
                            <button type="button" onClick={() => this.moreData()} style={{ display: this.state.btnMore }} className="bg-greenWalang text-[#ffffff] pr-4 font-medium rounded-full text-sm px-5 my-4 py-3 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">Tampilkan lebih banyak</button>
                          </center>
                        </div>
                      }
                    </InfiniteScroll> 
                  
                {this.state.data.length >= 1 &&
                  <div className="relative p-6 flex-auto overflow-y-auto">
                                      
                    <div className='grid grid-cols-2 gap-x-1 gap-y-1  lg:gap-x-2 lg:gap-y-2 lg:grid-cols-5 lg:mx-2 px-4 lg:px-0 mt-1 space-x-2'>
                    {
                        this.currentTableData().map(item => {
                            return (
                                <div className="bg-white relative">
                                    <img className='w-full product-img' src={item.cover} alt="" />
                                    <div className="line-clamp-2 font-semibold">{item.judul}</div>
                                    <div className="line-clamp-1 text-grayWalangDark text-sm pt-2">{item.penulis}</div>
                                    <div className="line-clamp-1 text-grayWalangDark text-sm pt-2">{item.penerbit}</div>
                                    <div className="flex items-center  pt-2">
                                        <div>
                                            <div className="justify-center items-center flex cursor-pointer" onClick={() => { this.deleteOutlet(item) }}>
                                            <svg className='h-6 w-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22.5172 16.7795L23.26 16.8829L22.5172 16.7795ZM22.2549 18.6645L22.9977 18.7679L22.2549 18.6645ZM9.74514 18.6645L10.488 18.5611L9.74514 18.6645ZM9.4828 16.7795L8.73996 16.8829L9.4828 16.7795ZM13.1836 25.7368L12.8921 26.4278L13.1836 25.7368ZM10.4751 22.5603L11.1791 22.3017L10.4751 22.5603ZM21.5249 22.5603L22.2289 22.819V22.819L21.5249 22.5603ZM18.8164 25.7368L18.5248 25.0458H18.5248L18.8164 25.7368ZM9.74664 12.9291C9.70746 12.5167 9.34142 12.2142 8.92906 12.2534C8.5167 12.2925 8.21418 12.6586 8.25336 13.0709L9.74664 12.9291ZM23.7466 13.0709C23.7858 12.6586 23.4833 12.2925 23.0709 12.2534C22.6586 12.2142 22.2925 12.5167 22.2534 12.9291L23.7466 13.0709ZM24 11.75C24.4142 11.75 24.75 11.4142 24.75 11C24.75 10.5858 24.4142 10.25 24 10.25V11.75ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75V10.25ZM20 11V11.75H20.75V11H20ZM12 11H11.25V11.75H12V11ZM21.7744 16.6761L21.512 18.5611L22.9977 18.7679L23.26 16.8829L21.7744 16.6761ZM10.488 18.5611L10.2256 16.6761L8.73996 16.8829L9.0023 18.7679L10.488 18.5611ZM16 25.25C14.4708 25.25 13.9254 25.2358 13.4752 25.0458L12.8921 26.4278C13.6891 26.7642 14.6056 26.75 16 26.75V25.25ZM9.0023 18.7679C9.282 20.7777 9.43406 21.9017 9.77109 22.819L11.1791 22.3017C10.9116 21.5736 10.7785 20.6488 10.488 18.5611L9.0023 18.7679ZM13.4752 25.0458C12.5528 24.6566 11.695 23.7058 11.1791 22.3017L9.77109 22.819C10.3857 24.4918 11.4821 25.8328 12.8921 26.4278L13.4752 25.0458ZM21.512 18.5611C21.2215 20.6488 21.0884 21.5736 20.8209 22.3017L22.2289 22.819C22.5659 21.9017 22.718 20.7777 22.9977 18.7679L21.512 18.5611ZM16 26.75C17.3944 26.75 18.3109 26.7642 19.1079 26.4278L18.5248 25.0458C18.0746 25.2358 17.5292 25.25 16 25.25V26.75ZM20.8209 22.3017C20.305 23.7058 19.4472 24.6566 18.5248 25.0458L19.1079 26.4278C20.5179 25.8328 21.6143 24.4918 22.2289 22.819L20.8209 22.3017ZM10.2256 16.6761C10.0035 15.08 9.83766 13.887 9.74664 12.9291L8.25336 13.0709C8.34819 14.069 8.51961 15.2995 8.73996 16.8829L10.2256 16.6761ZM23.26 16.8829C23.4804 15.2995 23.6518 14.069 23.7466 13.0709L22.2534 12.9291C22.1623 13.887 21.9965 15.08 21.7744 16.6761L23.26 16.8829ZM24 10.25H8V11.75H24V10.25ZM19.25 10V11H20.75V10H19.25ZM20 10.25H12V11.75H20V10.25ZM12.75 11V10H11.25V11H12.75ZM16 6.75C17.7949 6.75 19.25 8.20507 19.25 10H20.75C20.75 7.37665 18.6234 5.25 16 5.25V6.75ZM16 5.25C13.3766 5.25 11.25 7.37665 11.25 10H12.75C12.75 8.20507 14.2051 6.75 16 6.75V5.25Z" fill="#F51212" />
                                            </svg>
                                            <a className="text-black text-sm text-center text-[10px] text-rose-500">Delete</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    </div>
                    <div className="flex justify-center pt-8">
                        <Pagination
                            className="pagination-bar"
                            currentPage={this.state.currentPage}
                            totalCount={this.state.data.length}
                            pageSize={PageSize}
                            onPageChange={
                                page => this.setState({ currentPage: page })
                            }
                        />
                    </div>
                </div>

                        } 
              </div>
                        
            </div>

            
          </div>

        }
      </div>
    );

  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <ContentToko {...props} navigate={navigate} params={useParams()} />
}

export default WithNavigate;
